import {
  useQuery,
} from '@tanstack/react-query';
import {
  notEmptyString,
} from '@populateui/utils';
import {
  normalizeFilterableSettings,
} from 'core/Filters/util';
import {
  CallDetailsDTO,
  SettingsDTO,
} from 'dtos';
import {
  getApiBlandGetCallDetails,
  getApiSettingsGetCcmMonthlyDashboardFilterSettings,
} from 'endpoints';

export function useGetCcmMonthlyDashboardFilterSettings() {
  return useQuery<SettingsDTO, Error>({
    queryKey: ['ccm-monthly-dashboard-filter-settings'],
    queryFn: getApiSettingsGetCcmMonthlyDashboardFilterSettings,
  });
}

export function useCcmMonthlyDashboardFilterMetaComponents() {
  const { data } = useGetCcmMonthlyDashboardFilterSettings();

  return normalizeFilterableSettings(data?.filterableSettings ?? []);
}

export function useGetCcmCallDetails(callId?: string | null, enabled: boolean = true) {
  return useQuery<CallDetailsDTO, Error>({
    queryKey: ['ccm-monthly-call-details', callId],
    queryFn: () => getApiBlandGetCallDetails({ callId: callId ?? undefined }),
    enabled: enabled && notEmptyString(callId),
  });
}
